import h from 'react-hyperscript';
import { Link, withRouter } from 'react-router-dom';
import Route from 'route-parser';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';

import VenueSelectorContainer from '../../containers/Venues/VenueSelectorContainer';
import { knownRoutes as routes } from '../../routes';

const getPathTokens = pathname => {
  const paths = ['/'];

  if (pathname === '/') {
    return paths;
  }

  pathname.split('/').reduce((prev, curr) => {
    const currPath = `${prev}/${curr}`;
    paths.push(currPath);

    return currPath;
  });

  return paths;
};

const getRouteMatch = path =>
  routes
    .map(({ path: key }) => {
      const params = new Route(key).match(path);

      return {
        didMatch: params !== false,
        params,
        key,
      };
    })
    .filter(item => item.didMatch)[0];

const getBreadcrumbs = ({ match, location }) => {
  const pathTokens = getPathTokens(location.pathname);

  return pathTokens.map((path, i) => {
    const routeMatch = getRouteMatch(path);
    const foundRoute = routes.find(route => routeMatch && route.path === routeMatch.key) || {};
    const { name, requiresVenueSelection = false } = foundRoute;

    return { name, path, requiresVenueSelection };
  });
};

const Breadcrumbs = ({ match, location, profile }) => {
  const breadcrumbs = getBreadcrumbs({ match, location });
  let isVenueSelectorRequired = false;

  let items = breadcrumbs.map(({ path, name, requiresVenueSelection }, i) => {
    const isLastItem = i === breadcrumbs.length - 1;
    const isBackItem = i === (breadcrumbs.length - 2 > 0 ? breadcrumbs.length - 2 : 0);

    if (isLastItem && requiresVenueSelection) {
      isVenueSelectorRequired = true;
    }

    return isLastItem
      ? h(BreadcrumbItem, { active: true, className: 'text-ellipse breadcrumb-leaf' }, name)
      : h(BreadcrumbItem, [h(Link, { to: path || '', className: isBackItem ? 'link-back-item' : '' }, name)]);
  });

  if (isVenueSelectorRequired) {
    items = [h(VenueSelectorContainer), ...items];
  }

  return h(Breadcrumb, items);
};

export default withRouter(Breadcrumbs);



// WEBPACK FOOTER //
// ./src/components/Breadcrumb/Breadcrumb.js